import React from "react";
import PropTypes from "prop-types";
import { Backdrop, CircularProgress } from "@material-ui/core";

/**
 * Shows a transparent overlay that covers all the webview and displays a circular progress spinner
 */
const BackDrop = ({ style, isOpen }) => {
  return (
    <Backdrop style={style} open={isOpen}>
      <CircularProgress
        color="primary"
        size={60}
        style={{ position: "relative" }}
      />
    </Backdrop>
  );
};

BackDrop.propTypes = {
  /** Custom styles for the backdrop overlay. */
  style: PropTypes.object.isRequired,
  /** Indicates that the backdrop is visible or not. */
  isOpen: PropTypes.bool.isRequired,
};

export default BackDrop;
